import { apiFetch } from './client';

export async function getNotifications(page = 1, pageSize = 10) {
  return apiFetch(`/notifications?page=${page}&pageSize=${pageSize}`);
}

export async function getUnreadCount() {
  return apiFetch('/notifications/unread-count');
}

export async function markAsRead(notificationId) {
  return apiFetch(`/notifications/${notificationId}/read`, {
    method: 'POST',
  });
}

export async function markAllAsRead() {
  return apiFetch('/notifications/read-all', {
    method: 'POST',
  });
}

export async function getVapidPublicKey() {
  return apiFetch('/notifications/vapid-public-key');
}

export async function subscribePush(subscription, language = 'de') {
  return apiFetch('/notifications/push-subscribe', {
    method: 'POST',
    body: JSON.stringify({
      endpoint: subscription.endpoint,
      p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh')))),
      auth: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth')))),
      language: language?.toLowerCase().startsWith('en') ? 'en' : 'de',
    }),
  });
}

export async function unsubscribePush(endpoint) {
  const ep = typeof endpoint === 'string' ? endpoint : endpoint?.endpoint;
  return apiFetch('/notifications/push-unsubscribe', {
    method: 'POST',
    body: JSON.stringify({ endpoint: ep }),
  });
}
